/**
 * HEALING SOUNDS - MATERIAL SHOWCASE
 * Version: 1.0 Premium - With All Enhancements
 * Features: Swipe gestures, keyboard navigation, progress bar, lazy loading
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // ========================================
  // ÉLÉMENTS DOM
  // ========================================
  
  const materialBtns = document.querySelectorAll('.material-btn');
  const materialContents = document.querySelectorAll('.material-content');
  const showcase = document.querySelector('.material-showcase');
  const sliderTrack = document.querySelector('.material-slider__track');
  
  if (!materialBtns.length || !materialContents.length) return;
  
  const totalMaterial = materialBtns.length;
  let currentIndex = 0;
  
  // ========================================
  // DÉTECTION : 1 SEUL MATÉRIAU
  // ========================================
  
  if (totalMaterial === 1) {
    showcase.classList.add('single-material');
  }
  
  // ========================================
  // GESTION DES CLICS SUR LES BOUTONS
  // ========================================
  
  function switchMaterial(targetMaterial, buttonIndex) {
    currentIndex = buttonIndex;
    
    // Update active button
    materialBtns.forEach(b => b.classList.remove('active'));
    materialBtns[buttonIndex].classList.add('active');
    
    // Update active content
    materialContents.forEach(content => {
      if (content.dataset.material === targetMaterial) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
    
    // Scroll le slider horizontalement pour voir le bouton actif
    if (sliderTrack && materialBtns[buttonIndex]) {
      materialBtns[buttonIndex].scrollIntoView({ 
        behavior: 'smooth', 
        block: 'nearest', 
        inline: 'center' 
      });
    }
  }
  
  materialBtns.forEach((btn, index) => {
    btn.addEventListener('click', function() {
      const material = this.dataset.material;
      switchMaterial(material, index);
    });
  });
  
  // ========================================
  // AUTO-SCROLL HORIZONTAL (CENTRER LE BOUTON ACTIF)
  // ========================================
  
  const activeBtn = document.querySelector('.material-btn.active');
  if (activeBtn && totalMaterial > 3) {
    setTimeout(() => {
      activeBtn.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'nearest', 
        inline: 'center' 
      });
    }, 100);
  }
  
  // ========================================
  // KEYBOARD NAVIGATION (ACCESSIBILITÉ)
  // ========================================
  
  document.addEventListener('keydown', function(e) {
    const activeIndex = Array.from(materialBtns).findIndex(btn => 
      btn.classList.contains('active')
    );
    
    if (e.key === 'ArrowRight' && activeIndex < totalMaterial - 1) {
      // Next material
      const nextMaterialBtn = materialBtns[activeIndex + 1];
      const nextMaterial = nextMaterialBtn.dataset.material;
      switchMaterial(nextMaterial, activeIndex + 1);
      nextMaterialBtn.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    } else if (e.key === 'ArrowLeft' && activeIndex > 0) {
      // Previous material
      const prevMaterialBtn = materialBtns[activeIndex - 1];
      const prevMaterial = prevMaterialBtn.dataset.material;
      switchMaterial(prevMaterial, activeIndex - 1);
      prevMaterialBtn.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    }
  });
  
  // ========================================
  // SWIPE GESTURES (MOBILE)
  // ========================================
  
  if (contentWrapper) {
    let touchStartX = 0;
    let touchEndX = 0;
    let touchStartY = 0;
    let touchEndY = 0;
    
    contentWrapper.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });
    
    contentWrapper.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe();
    }, { passive: true });
    
    function handleSwipe() {
      const swipeThreshold = 50;
      const swipeDistanceX = Math.abs(touchEndX - touchStartX);
      const swipeDistanceY = Math.abs(touchEndY - touchStartY);
      
      // Seulement si le swipe est principalement horizontal
      if (swipeDistanceX > swipeDistanceY) {
        const activeIndex = Array.from(materialBtns).findIndex(btn => 
          btn.classList.contains('active')
        );
        
        if (touchEndX < touchStartX - swipeThreshold && activeIndex < totalMaterial - 1) {
          // Swipe left → next material
          const nextMaterialBtn = materialBtns[activeIndex + 1];
          const nextMaterial = nextMaterialBtn.dataset.material;
          switchMaterial(nextMaterial, activeIndex + 1);
        }
        
        if (touchEndX > touchStartX + swipeThreshold && activeIndex > 0) {
          // Swipe right → previous material
          const prevMaterialBtn = materialBtns[activeIndex - 1];
          const prevMaterial = prevMaterialBtn.dataset.material;
          switchMaterial(prevMaterial, activeIndex - 1);
        }
      }
    }
  }
  
  // ========================================
  // LAZY LOADING IMAGES
  // ========================================
  
  const lazyImages = document.querySelectorAll('.material-content__image img');
  
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.classList.add('lazyloaded');
            imageObserver.unobserve(img);
          }
        }
      });
    });
    
    lazyImages.forEach(img => imageObserver.observe(img));
  } else {
    // Fallback pour navigateurs anciens
    lazyImages.forEach(img => {
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.classList.add('lazyloaded');
      }
    });
  }
  
  // Parallax effect enlevé pour performance
  
  // ========================================
  // ANALYTICS (OPTIONNEL)
  // ========================================
  
  // Track quel matériau est le plus consulté
  materialBtns.forEach((btn, index) => {
    btn.addEventListener('click', function() {
      const material = this.dataset.material;
      
      // Google Analytics (si configuré)
      if (typeof gtag !== 'undefined') {
        gtag('event', 'material_view', {
          'event_category': 'Material Showcase',
          'event_label': material,
          'value': index
        });
      }
      
      // Shopify Analytics (si disponible)
      if (typeof window.ShopifyAnalytics !== 'undefined') {
        window.ShopifyAnalytics.lib.track('Material Viewed', {
          material: material,
          position: index + 1
        });
      }
    });
  });
  
  // ========================================
  // INIT PROGRESS BAR
  // ========================================
  
  if (progressBar) {
    const activeIndex = Array.from(materialBtns).findIndex(btn => 
      btn.classList.contains('active')
    );
    const initialPercentage = ((activeIndex + 1) / totalMaterial) * 100;
    progressBar.style.width = initialPercentage + '%';
  }
  
  console.log('✨ Material Showcase initialized with', totalMaterial, 'materials');
  
});
